import { z } from 'zod';

export const representativesFormSchema = z.object({
  id: z.string(),
  fullName: z.string().min(3),
  email: z.string().email(),
  accessRight: z.number({ message: '' }),
  workingWithApplications: z.number(),
});
